import { render } from "./PPAPApplicabilityInspectionList.vue?vue&type=template&id=6ddc6078&scoped=true"
import script from "./PPAPApplicabilityInspectionList.vue?vue&type=script&lang=js"
export * from "./PPAPApplicabilityInspectionList.vue?vue&type=script&lang=js"

import "./PPAPApplicabilityInspectionList.vue?vue&type=style&index=0&id=6ddc6078&lang=scss"
import "./PPAPApplicabilityInspectionList.vue?vue&type=style&index=1&id=6ddc6078&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddc6078"]])

export default __exports__